import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Button } from '../../components/Button';
import { H6 } from '../../components/H6';
import { InfoSection } from '../../components/MyPage/InfoSection';
import { ProductSection } from '../../components/MyPage/ProductSection';
import { ShippingInfoSection } from '../../components/MyPage/ShippingInfoSection';
import { Section } from '../../components/Section';
import { Table } from '../../components/Table';
import useOrderDetail from '../../hooks/useOrderDetail';
import {
  OrderChangeSizeDto,
  OrderChangeSizeItemDto,
  OrderPaidProduct,
  TOrderDetail,
} from '../../types/types';
import PaymentInfoMobile from '../../components/PaymentInfoMobile';
import PaymentInfoPC from '../../components/PaymentInfoPC';
import ProductEditSizeItem from '../../components/ProductEditSizeItem';
import OrderNumberSection from '../../components/OrderNumberSection';
import { changeSizeBeforeShip, getOrderHistoryDetail } from '../../apis/orders';
import { nToast } from '../../plugins/reactToast';
import {DirectoryBar} from "../../components/DirectoryBar";

export const MyPageOrdersEditSize = () => {
  const { orderNumber } = useParams<{ orderNumber: string }>();
  const { order, setOrder } = useOrderDetail(orderNumber);
  const history = useHistory();
  // @ts-ignore
  const {
    nOrder,
    products,
  }: { nOrder: TOrderDetail; products: OrderPaidProduct[] } =
    history.location.state;
  const [targetSizeIds, setTargetSizeIds] = useState<OrderChangeSizeItemDto[]>(
    [],
  );

  useEffect(() => {
    let list: number[] = [];
    products.forEach(item => list.push(item.orderProductId));
    setTargetSizeIds([]);
  }, []);

  useEffect(() => {
    if (nOrder) {
      setOrder(nOrder);
    } else {
      getOrderHistoryDetail(orderNumber)
        .then(r => setOrder(r.data.payload))
        .catch(e => console.log(e));
    }
  }, [orderNumber]);

  const editSizeRequest = () => {
    if (targetSizeIds.length === 0) {
      nToast('변경하실 사이즈를 선택해주세요');
    } else {
      const data: OrderChangeSizeDto = {
        customerName: order?.customerName,
        customerPhone: order?.customerPhone,
        items: targetSizeIds,
      };
      changeSizeBeforeShip(orderNumber, data).then(r => {
        nToast(`사이즈 변경 신청이 완료되었습니다`);
        history.replace(`mypage/orders/${orderNumber}`);
      }).catch(e => console.log(e));
      setTargetSizeIds([]);
    }
  };

  if (!order) return null;
  return (
    <>
      <DirectoryBar text="사이즈 변경" backArrow className="md:hidden"/>
      <div
        className={
          nOrder
            ? 'md:mx-auto md:my-30 max-w-screen-xl space-y-14'
            : 'space-y-14'
        }>
        <Section className="space-y-4 text-13">
          <div className="flex justify-between border-b-2 pb-2">
            <H6>주문상세내역</H6>
            {/*<Link*/}
            {/*    to="/my/orders/all/product/:id/cancel"*/}
            {/*    className="text-13 bg-gray-100 px-3 py-2"*/}
            {/*>*/}
            {/*    전체 주문 취소*/}
            {/*</Link>*/}
          </div>
          <OrderNumberSection
            orderNumber={order.orderNumber}
            orderedAt={order.orderedAt!}
          />
        </Section>

        {/* Desktop Product Section */}
        <ProductSection
          className="hidden md:block"
          order={order}
          content={
            <>
              <Table className="mt-5">
                <Table.Head>
                  <Table.Row>
                    {/*<Table.Th>*/}
                    {/*    <Checkbox className="bg-white border border-gray-300"/>*/}
                    {/*</Table.Th>*/}
                    <Table.Th>상품</Table.Th>
                    <Table.Th>사이즈</Table.Th>
                    <Table.Th>적립금 적립</Table.Th>
                    <Table.Th>결제 금액</Table.Th>
                  </Table.Row>
                </Table.Head>
                <Table.Body>
                  {products.map((product, index) => (
                    <ProductEditSizeItem
                      order={order}
                      product={product}
                      key={index}
                      onSelectSize={(orderProductId, id) =>
                        setTargetSizeIds([
                          ...targetSizeIds,
                          {
                            orderProductId: orderProductId,
                            changeToProductSizeId: id,
                          },
                        ])
                      }
                    />
                  ))}
                </Table.Body>
              </Table>

              <div className="flex flex-row-reverse space-x-reverse space-x-4">
                <Button
                  onClick={editSizeRequest}
                  text="저장"
                  className="filled-gray-900 px-12"
                />
                <Button
                  text="취소"
                  className="bg-gray-100  px-12"
                  onClick={() => history.goBack()}
                />
              </div>
            </>
          }
        />

        {/* Mobile Product Section */}
        <ProductSection
          className="md:hidden"
          order={order}
          content={
            <>
              <div className="space-y-3">
                {products.map((product, index) => (
                  <ProductEditSizeItem
                    order={order}
                    product={product}
                    key={index}
                    isMobile={true}
                    onSelectSize={(orderProductId, id) =>
                      setTargetSizeIds([
                        ...targetSizeIds,
                        {
                          orderProductId: orderProductId,
                          changeToProductSizeId: id,
                        },
                      ])
                    }
                  />
                ))}
              </div>

              <div className="flex flex-row-reverse space-x-reverse space-x-4 pt-4">
                <Button
                  onClick={editSizeRequest}
                  text="저장"
                  className="filled-gray-900 px-12"
                />
                <Button
                  text="취소"
                  className="bg-gray-100  px-12"
                  onClick={() => history.goBack()}
                />
              </div>
            </>
          }
        />

        <InfoSection name={order.customerName!} phone={order.customerPhone!} />

        <ShippingInfoSection hideActions order={order} />

        {/* Desktop 결제 정보 Section */}
        <Section className="hidden md:block text-13">
          <H6 className="border-b-2 pb-2">결제 정보</H6>

          <PaymentInfoPC order={order} />
        </Section>

        {/* Mobile 결제 정보 Section */}
        <Section className="md:hidden text-13">
          <div className="border-b-2 pb-2 mb-4 flex justify-between items-center">
            <H6 className="">결제 정보</H6>
          </div>

          <PaymentInfoMobile order={order} />
        </Section>
      </div>
    </>
  );
};
